import { PURGE } from "redux-persist";
import { User } from "types";

type PatientReducer = {
  type: string;
  payload: any;
};

const initialState = {
  patients: null as Array<User> | null,
};

export default (state = initialState, { type, payload }: PatientReducer) => {
  switch (type) {
    case "ADD_PATIENT":
      if (!state.patients) return state;
      return {
        ...state,
        patients: [...state.patients, payload],
      };
    case "UPDATE_PATIENT":
      if (!state.patients) return state;
      return {
        ...state,
        patients: state.patients.map((patient) =>
          patient.uuid === payload.uuid
            ? {
                ...patient,
                ...payload,
              }
            : patient
        ),
      };
    case "FETCH_PATIENTS":
      // Sort patients by createdAt field to show new patients on top
      const sortedPatients = payload.sort(
        (a: User, b: User) => Number(b.createdAt) - Number(a.createdAt)
      );
      return {
        ...state,
        patients: [...sortedPatients],
      };
    case "REMOVE_PATIENT":
      if (!state.patients) return state;
      return {
        ...state,
        patients: state.patients.filter((patient) => patient !== payload.uuid),
      };
    case PURGE:
      return initialState;
    case "CLEAR_ORGANIZATION_DATA":
      return initialState;
    default:
      return state;
  }
};
